import { render, staticRenderFns } from "./AddSanction.vue?vue&type=template&id=93c8b10e"
import script from "./AddSanction.vue?vue&type=script&lang=js"
export * from "./AddSanction.vue?vue&type=script&lang=js"
import style0 from "./AddSanction.vue?vue&type=style&index=0&id=93c8b10e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports